import { render } from "./verified.vue?vue&type=template&id=771afb8c"
import script from "./verified.vue?vue&type=script&lang=js"
export * from "./verified.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__